export const FormActionTypes = ['trial', 'demo', 'url'] as const;

export type FormActionType = (typeof FormActionTypes)[number];
